module.exports = __webpack_public_path__ + "static/default.cf772b34.png";